/* Thermik theme JS: buy box, gifts, carousels, reviews, countdown */
(function () {
  const money = (c) => (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : '$' + (c / 100).toFixed(2);
  const fmt = (cents) => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); } catch (e) { return money(cents); } };

  function thOpenCart() {
    if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') { window.kachingCartApi.openCart({ refetchCart: true }); return true; }
    return false;
  }
  window.thOpenCart = thOpenCart;
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a#cart-icon-bubble, a.header__icon--cart, header a[href="/cart"]');
    if (a && thOpenCart()) e.preventDefault();
  }, true);

  function initBuyBox(root) {
    const form = root.querySelector('[data-th-form]') || document.querySelector('[data-th-form]');
    if (!form) return;
    const vIn = form.querySelector('[data-th-variant-input]'), qIn = form.querySelector('[data-th-qty-input]'), pIn = form.querySelector('[data-th-plan-input]');
    const sub = root.querySelector('[data-th-sub]');
    const offers = [...root.querySelectorAll('[data-th-offer]')];
    const subOn = () => sub && sub.checked;
    function apply() {
      const active = offers.find(o => o.querySelector('.moonbundle-option-active')) || offers[0];
      offers.forEach(o => {
        const base = +o.dataset.price, disc = sub ? +sub.dataset.discount : 0;
        // data-price is server-rendered with subscription state at load; recompute from undiscounted base
        if (!o.dataset.base) o.dataset.base = (sub && sub.defaultChecked) ? Math.round(base * 100 / (100 - disc)) : base;
        const p = subOn() ? Math.round(o.dataset.base * (100 - disc) / 100) : +o.dataset.base;
        const el = o.querySelector('[data-th-offer-price]'); if (el) el.textContent = fmt(p);
      });
      if (active) { vIn.value = active.dataset.variant; qIn.value = active.dataset.qty; }
      const planForQty = (q) => !sub ? '' : (q >= 6 ? (sub.getAttribute('data-plan-12w') || sub.dataset.plan) : (q >= 4 ? (sub.getAttribute('data-plan-8w') || sub.dataset.plan) : (sub.getAttribute('data-plan-4w') || sub.dataset.plan)));
      const activePlan = subOn() ? planForQty(active ? +active.dataset.qty : +qIn.value) : '';
      if (pIn) { pIn.value = activePlan || ''; pIn.disabled = !subOn() || !activePlan; }
      document.querySelectorAll('[data-th-price]').forEach(e => { if (active) e.textContent = active.querySelector('[data-th-offer-price]').textContent; });
      const top = active && offers.indexOf(active) === offers.length - 1;
      root.querySelectorAll('[data-th-gift-unlock]').forEach(g => {
        const rule = g.dataset.thGiftUnlock || 'sub';
        const unlocked = subOn() && (rule !== 'sub_top' || top);
        g.classList.toggle('th-gift-locked', !unlocked); g.dataset.thUnlocked = unlocked ? '1' : '';
      });
    }
    offers.forEach(o => o.addEventListener('click', () => {
      offers.forEach(x => x.querySelector('.moonbundle-option').classList.remove('moonbundle-option-active'));
      o.querySelector('.moonbundle-option').classList.add('moonbundle-option-active'); apply();
    }));
    if (sub) sub.addEventListener('change', () => { const c = sub.closest('.moonbundle-subscription-toggle').querySelector('.moonbundle-subscription-control'); c && c.classList.toggle('checked', sub.checked); apply(); });
    apply();
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[name=add]'); btn && btn.setAttribute('disabled', '');
      const isSub = subOn();
      const chosenPlan = isSub && sub ? (+qIn.value >= 6 ? (sub.getAttribute('data-plan-12w') || sub.dataset.plan) : (+qIn.value >= 4 ? (sub.getAttribute('data-plan-8w') || sub.dataset.plan) : (sub.getAttribute('data-plan-4w') || sub.dataset.plan))) : '';
      if (pIn) { pIn.value = chosenPlan || ''; pIn.disabled = !isSub || !chosenPlan; }
      const cadence = +qIn.value >= 6 ? 'Every 12 Weeks' : (+qIn.value >= 4 ? 'Every 8 Weeks' : 'Every 4 Weeks');
      const items = [{ id: +vIn.value, quantity: +qIn.value, ...(isSub && chosenPlan ? { selling_plan: +chosenPlan } : {}), ...(isSub ? { properties: { Subscription: cadence + ' (Save 20%)' } } : {}) }];
      const giftIds = [...root.querySelectorAll('[data-th-gift-unlock]')].filter(g => g.dataset.thUnlocked && +g.dataset.thGift).map(g => +g.dataset.thGift);
      const allGiftIds = [...root.querySelectorAll('[data-th-gift]')].map(g => +g.dataset.thGift).filter(Boolean);
      try {
        const nf = (window.__thGetNativeFetch && window.__thGetNativeFetch()) || window.__kachingCartOriginalFetch || window.__thNativeFetch || fetch;
        const cart = await (await nf('/cart.js')).json();
        // Replace, don't stack: drop existing JointWise lines (any plan) and gift lines first
        const jointPid = +(vIn.dataset.thProduct || 0);
        const kill = {};
        cart.items.forEach(i => { if (i.variant_id === +vIn.value || (jointPid && i.product_id === jointPid) || allGiftIds.includes(i.variant_id)) kill[i.key] = 0; });
        if (Object.keys(kill).length) {
          const u = await nf('/cart/update.js?kaching_cart_ignore=true', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: kill }) });
          if (!u.ok) throw new Error('Could not update cart');
        }
        const giftItems = giftIds.map(id => ({ id, quantity: 1, properties: { _gift: 'Free gift' } }));
        const r = await fetch('/cart/add.js?opens_cart=never', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) { const j = await r.json(); throw new Error(j.description || j.message); }
        if (giftItems.length) {
          await nf('/cart/add.js?opens_cart=never&kaching_cart_ignore=true', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: giftItems }) });
        }
        const updBody = { discount: (isSub && !chosenPlan) ? 'SUBSCRIBE20' : '' };
        if (typeof window.thGetTrackingAttributes === 'function') updBody.attributes = window.thGetTrackingAttributes();
        const updRes = await nf('/cart/update.js?kaching_cart_ignore=true', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(updBody) });
        try { const updatedCart = await updRes.json(); if (updatedCart && updatedCart.items) window.__thCartCache = updatedCart; } catch (_) {}
        try {
          const act = offers.find(o => o.querySelector('.moonbundle-option-active')) || offers[0];
          const pe = act && act.querySelector('[data-th-offer-price]');
          const cents = pe ? Math.round(parseFloat(pe.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
          if (window.thMetaEvent) window.thMetaEvent('AddToCart', { content_ids: [String(vIn.value)], content_type: 'product', contents: [{ id: String(vIn.value), quantity: +qIn.value }], value: cents / 100, currency: 'USD' });
        } catch (e) {}
        btn && btn.removeAttribute('disabled');
        if (!thOpenCart()) window.location.href = '/cart';
      } catch (err) {
        const er = form.querySelector('[data-th-error]'); if (er) { er.textContent = err.message; er.parentElement.hidden = false; }
        btn && btn.removeAttribute('disabled');
      }
    });
  }

  /* Gift auto-add: gift blocks carry the gift variant id (set the gift product to $0 / discounted 100%). */
  async function syncGifts() {
    const cfgEl = document.querySelector('[data-th-gift-config]');
    let cfg = cfgEl ? JSON.parse(cfgEl.textContent) : (window.ThermikGifts || null);
    const gifts = [...document.querySelectorAll('[data-th-gift]')].map(g => ({ id: +g.dataset.thGift, min: +(g.dataset.minUnits || 1) })).filter(g => g.id);
    if (cfg) localStorage.setItem('thGifts', JSON.stringify({ product_id: cfg.product_id, auto: cfg.auto, gifts }));
    const saved = JSON.parse(localStorage.getItem('thGifts') || 'null');
    if (!saved || !saved.auto || !saved.gifts.length) return;
    const nf = (window.__thGetNativeFetch && window.__thGetNativeFetch()) || window.__kachingCartOriginalFetch || window.__thNativeFetch || fetch;
    const cart = await (await nf('/cart.js')).json();
    if (cart && cart.items) window.__thCartCache = cart;
    const units = cart.items.filter(i => i.product_id === saved.product_id).reduce((a, i) => a + i.quantity, 0);
    const updates = {};
    saved.gifts.forEach(g => {
      const line = cart.items.find(i => i.variant_id === g.id);
      const want = units >= g.min ? Math.min(line ? line.quantity : 0, 1) : 0; // cart page only removes gifts; adding happens in the buy box by unlock state
      if ((line ? line.quantity : 0) !== want) updates[g.id] = want;
    });
    const toAdd = Object.entries(updates).filter(([id, q]) => q > 0 && !cart.items.find(i => i.variant_id === +id));
    const toChange = Object.entries(updates).filter(([id]) => cart.items.find(i => i.variant_id === +id));
    if (toAdd.length) await nf('/cart/add.js?opens_cart=never&kaching_cart_ignore=true', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: toAdd.map(([id]) => ({ id: +id, quantity: 1, properties: { _gift: 'Free gift' } })) }) });
    if (toChange.length) await nf('/cart/update.js?kaching_cart_ignore=true', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: Object.fromEntries(toChange) }) });
    if (toAdd.length || toChange.length) document.dispatchEvent(new CustomEvent('thermik:gifts-synced'));
  }
  window.ThermikSyncGifts = syncGifts;

  function initGallery() {
    document.querySelectorAll('.thumbnail-list__item').forEach(t => t.addEventListener('click', () => {
      const target = document.querySelector('[data-media-id="' + t.dataset.target + '"]'); if (!target) return;
      target.parentElement.querySelectorAll('.is-active').forEach(x => x.classList.remove('is-active')); target.classList.add('is-active');
      target.parentElement.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      t.parentElement.querySelectorAll('[aria-current]').forEach(b => b.removeAttribute('aria-current')); t.querySelector('button') && t.querySelector('button').setAttribute('aria-current', 'true');
    }));
  }

  function carousel(root, track, card, prev, next, dot) {
    const tr = root.querySelector(track); if (!tr) return;
    const cards = [...tr.querySelectorAll(card)]; let i = 0;
    const go = (n) => { i = (n + cards.length) % cards.length; tr.scrollTo({ left: cards[i].offsetLeft - tr.offsetLeft, behavior: 'smooth' }); root.querySelectorAll(dot).forEach((d, k) => d.classList.toggle('is-active', k === i)); };
    root.querySelector(prev) && root.querySelector(prev).addEventListener('click', () => go(i - 1));
    root.querySelector(next) && root.querySelector(next).addEventListener('click', () => go(i + 1));
    root.querySelectorAll(dot).forEach((d, k) => { d.addEventListener('click', () => go(k)); d.classList.toggle('is-active', k === 0); });
  }

  function initReviews(root) {
    const list = root.querySelector('#rg-list'); if (!list) return;
    const cards = [...list.querySelectorAll('.rg-card')];
    let filter = 'all';
    const sort = root.querySelector('#rg-sort');
    function render() {
      const s = sort ? sort.value : 'rating';
      cards.sort((a, b) => s === 'oldest' ? a.dataset.date.localeCompare(b.dataset.date) : s === 'newest' ? b.dataset.date.localeCompare(a.dataset.date) : (b.dataset.rating - a.dataset.rating) || b.dataset.date.localeCompare(a.dataset.date));
      cards.forEach(c => { c.hidden = !(filter === 'all' || c.dataset.tags.split(',').map(x => x.trim()).includes(filter)); list.appendChild(c); });
    }
    root.querySelectorAll('[data-filter]').forEach(b => b.addEventListener('click', () => { filter = b.dataset.filter; root.querySelectorAll('[data-filter]').forEach(x => x.classList.toggle('active', x === b)); render(); }));
    sort && sort.addEventListener('change', render);
  }

  function initCountdown() {
    const cd = document.querySelector('[data-th-countdown]'), ar = document.querySelector('[data-th-arrival]');
    if (!cd) return;
    const tick = () => { const n = new Date(), e = new Date(n); e.setHours(23, 59, 59); const m = Math.floor((e - n) / 60000); cd.textContent = Math.floor(m / 60) + 'h ' + (m % 60) + 'm'; };
    tick(); setInterval(tick, 30000);
    if (ar) { let d = new Date(), k = +ar.dataset.days || 5; while (k > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k--; } ar.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  }

  function initSticky() {
    const s = document.querySelector('.sticky-atc'), btn = document.querySelector('.lm-main-button'); if (!s || !btn) return;
    s.style.position = 'fixed'; s.style.left = '0'; s.style.right = '0'; s.style.top = 'auto'; s.style.zIndex = '50';
    const upd = (past) => { s.style.bottom = past ? '0px' : '-200px'; };
    if (!btn.offsetParent) { upd(true); return; }
    new IntersectionObserver(([e]) => upd(!e.isIntersecting && e.boundingClientRect.top < 0)).observe(btn);
  }

  function init() {
    document.documentElement.style.overflowY = 'auto'; document.body.classList.remove('klaviyo-prevent-body-scrolling');
    document.querySelectorAll('[data-th-buybox]').forEach(b => initBuyBox(b.closest('section') || document));
    initGallery(); initCountdown(); initSticky();
    document.querySelectorAll('.reasons').forEach(r => carousel(r, '[data-reasons-track]', '[data-reasons-card]', '[data-reasons-prev]', '[data-reasons-next]', '[data-reasons-dot]'));
    document.querySelectorAll('.compounds').forEach(r => carousel(r, '[data-compounds-track]', '[data-compounds-card]', '[data-compounds-prev]', '[data-compounds-next]', '.x-none'));
    document.querySelectorAll('.rg-wrap').forEach(initReviews);
    if (document.body.dataset.template && /cart/.test(document.body.dataset.template)) syncGifts();
    document.addEventListener('cart:updated', syncGifts);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
